module.exports = __webpack_public_path__ + "static/media/19ESCAP37.f7f8a669.jpg";